import React from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'
import UniversalLink from 'components/UniversalLink'

import theme from 'theme'

import PostHero from 'components/blog/PostHero'

import IconDynamicArrow from '@anvilco-pkg/ui/components/Icon/IconDynamicArrow'

const StyledPostHero = styled(PostHero)`
  transition: transform 300ms ease 0s;
  transform: translateY(0px);
  position: relative;
  z-index: -1;
`

const TextContainer = styled(Flex).attrs({
  flexDirection: 'column',
  px: 35,
  py: 25,
})`
  transition: transform 300ms ease 0s;
  transform: translateY(40px);
  margin-top: -40px;
  flex: 1;
`

const ReadMoreLink = styled(Flex).attrs({
  alignItems: 'center',
})`
  opacity: 0;
  transition:
    opacity 1s ease 0s,
    background-color 1s ease 0s;
  margin-top: auto;
  padding-top: 20px;

  div {
    font-weight: ${theme.fontWeights.bold};
    margin-right: 10px;
  }
`

export const Container = styled(UniversalLink)`
  display: flex;
  flex-direction: column;

  border: 1px solid ${theme.colors.blacks[20]};
  transition: border 300ms ease 0s;

  && {
    color: ${theme.colors.black};
    text-decoration: none;
  }

  :hover {
    border: 1px solid ${theme.colors.blacks[30]};

    && {
      color: ${theme.colors.black};
      text-decoration: none;
    }

    ${StyledPostHero} {
      transform: translateY(-32px);
    }

    ${TextContainer} {
      transform: translateY(0px);
      background-color: white;
    }

    ${ReadMoreLink} {
      opacity: 1;
    }
  }
`

const Title = styled.div`
  font-size: 18px;
  font-weight: ${theme.fontWeights.bold};
`

const Description = styled.div`
  margin-top: 16px;
  font-weight: 15px;
  color: ${theme.colors.blacks[60]};
`

export default function SimplePostSummary ({ to, image, title, description }) {
  return (
    <Container to={to}>
      <StyledPostHero image={image} />
      <TextContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <ReadMoreLink>
          <div>Read more</div>
          <IconDynamicArrow direction="right" width={50} />
        </ReadMoreLink>
      </TextContainer>
    </Container>
  )
}
